@if (!newBillingDesign) {
  <p class="subheading">{{ subHeading }}</p>
  <p class="pad-top-10">
    Current due date: <span>{{ paymentDueDate | dateFormat: 'MM/DD/YYYY' }}</span>
  </p>
  <div class="pad-top-20" [formGroup]="formGroup">
    <label for="paymentDate" class="subheading">Payment date</label>
    <p>
      <ds-form-control-container [control]="formGroup.controls['paymentDate']">
        <select
          id="paymentDate"
          class="icon fill"
          formControlName="paymentDate"
          data-cy="autoPayDateSelector"
        >
          @for (option of paymentDateOptions; track option) {
            <option [ngValue]="option">
              {{ option.text }}
            </option>
          }
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </p>
  </div>
}

@if (newBillingDesign) {
  <div class="pad-top-20" [formGroup]="formGroup">
    <label
      for="paymentDate"
      class="subheading neutral-800"
      dsContent
      [contentPath]="'billing.manageAutopay.paymentDateHeader'"
    ></label>
    @if (formGroup?.controls?.paymentFrequency?.value?.id === 'MINDUE') {
      <p>
        <ds-form-control-container [control]="formGroup.controls['paymentDate']">
          <select
            id="paymentDate"
            class="icon fill"
            formControlName="paymentDate"
            data-cy="autoPayDateSelector"
          >
            @for (option of paymentDateOptions; track option) {
              <option [ngValue]="option">
                {{ option.text }}
              </option>
            }
          </select>
          <span class="icon-chevron-down"></span>
        </ds-form-control-container>
      </p>
    }
  </div>
  @if (formGroup?.controls?.paymentFrequency?.value?.id === 'FULLPAY') {
    <div
      class="info-note"
      dsContent
      [contentPath]="'billing.manageAutopay.dueInfo'"
      [options]="{ minAmount: paymentDueDate | dateFormat: 'MMM D, YYYY' }"
    ></div>
  } @else {
    <div
      class="info-note"
      dsContent
      [contentPath]="'billing.manageAutopay.minDue'"
      [options]="{ minAmount: paymentDueDate | dateFormat: 'MMM D, YYYY' }"
    ></div>
  }
}
